import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { LinkConfig } from '../../config/routes/sidebar'
import { styled } from '@mui/material/styles'

const StyledListItemButton = styled(ListItemButton)`
  margin: ${({ theme }) => theme.spacing(0.5, 1.5)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  transition: ${({ theme }) => theme.transitions.create(['background-color', 'color'], { duration: 150 })};

  /* The selected item previously read only as a faint background tint, which is
     the weakest signal in the whole shell for the one thing that tells you where
     you are. It now takes the brand colour on the icon and label, and carries a
     marker so the state is not colour-only. */
  &.Mui-selected {
    color: ${({ theme }) => (theme.palette.mode === 'light' ? theme.palette.primary.dark : theme.palette.primary.main)};

    .MuiListItemIcon-root {
      color: inherit;
    }

    .MuiListItemText-primary {
      font-weight: 600;
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 18px;
      border-radius: 0 3px 3px 0;
      background-color: currentColor;
    }
  }
` as typeof ListItemButton

export interface SideBarListItemProps {
  link: LinkConfig
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

function SideBarListItem(props: SideBarListItemProps) {
  const { link, onClick } = props
  const location = useLocation()

  const selected = link.exact ? location.pathname === link.path : location.pathname.startsWith(link.path)

  // Not `dense` — that gave the primary navigation 40px rows, below the touch
  // target floor on the tablets this is used on.
  return (
    <StyledListItemButton onClick={onClick} selected={selected} component={RouterLink} to={link.path}>
      <ListItemIcon>{link.icon}</ListItemIcon>
      <ListItemText primary={link.label} />
    </StyledListItemButton>
  )
}

export default SideBarListItem
